import { useState, useContext } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../../Context";
import { BsPencil } from "react-icons/bs";
import { PiStudent, PiPencil, PiBuildingsLight } from "react-icons/pi";
import { MdOutlineArrowLeft } from "react-icons/md";

import { Loader, GET } from "../../../inc/Fetch"; 
import { ClassesDropdown } from "../../../components/Form"; 

import Task from "./Task"; 

import './css/Teacher_tasks.css'

export default function Teachers_tasks() {

    const { t } = useTranslation();

    const { successData, userData } = useContext(AppContext);
    const [userinfo, setuserinfo] = userData;

    const [filter, setfilter] = useState({})

    async function loadData() {
        let r = await GET(`task/myStudentTasks`);
        // console.log(r);
        
        return r;
    }

    const { data, error, isLoading } = useQuery(`myStudentTasks`, loadData); 

    if (isLoading) {
        return  <Loader />;
    }

    

    
    return (
        <div className='teacherTaskBox'>
            
            <div className='mainWidth shadow' style={{maxWidth:900}}>

                <nav className='breadcrumbs'>
                    <Link to={`/`}>{t("home")}</Link>
                    <MdOutlineArrowLeft />
                    <Link>{t("header_user_menu_2")}</Link>
                    
                
                </nav>

                <h1 className='mainTitle'>{t("header_user_menu_2")}</h1>
                
                <div className='tasksStatsBox ' >

                    <div >
                        <hr />
                        <p>
                            <b>{data?.stats[0]}</b>
                            <span>{t("tasks_stats_5")}</span>
                        </p>
                        <PiPencil />
                    </div>
                    <div >
                        <hr />
                        <p>
                            <b>{data?.stats[1]}</b>
                            <span>{t("tasks_stats_6")}</span>
                        </p>
                        <PiBuildingsLight />
                    </div>

                </div>


                <div className='filterBox'>
                    <div>
                        {t("tasks_tasks_count")} ({data?.tasks?.length})
                    </div>
                    <form>
                        {/* <input className='searchInput' type="search" placeholder={`${t("search")}..`} />

                        <select className='searchInput' style={{maxWidth:180}}>
                            <option value=''>- {t("classes")} -</option>
                            {userinfo?.classes?.map((v, k) => {
                                let cls = v?.split("-")[0];
                                let grd = v?.split("-")[1];
                                
                                return (
                                    <option key={k} value=''>{`${t("class")} ${global.Classes[cls]} (${global.Grades[grd]})`}</option>
                                );
                                // Cls.push({name: `${t("class")} ${global.Classes[cls]} (${global.Grades[grd]})`, val:`${cls}-${grd}`});
                            })}
                        </select> */}
                    </form>
                </div>

                <div className='myTaskBody studentTasksBox'>
                            
                    {data?.tasks?.map((vv, kk) => {
                        return (
                            <Task v={vv} key={kk} /> 
                        );
                    })}

                    {!data.tasks?.length ? <div className='noData'>{t("error",  { returnObjects: true })[1]}</div>: false}

                </div>

                

            </div>


        </div>
    )
}
